<section class="privacy-hero">
  <div class="container">
    <h1>Privacy Policy & SMS Terms</h1>
    <p class="subtitle">
      Please read our terms of service, mobile messaging terms, and privacy policy carefully.
    </p>
  </div>
</section>

<section class="privacy-content">
  <div class="container">
    <div class="privacy-grid">
      <div class="privacy-document-card">
        <h2>Mobile Terms of Service</h2>
        <p class="intro-text">Verbal Script used to obtain SMS consent.</p>

        <div class="script-box">
          <p>
            <span class="representative-label">League City Yacht Sales Representative:</span> "As
            part of our service with League City Yacht Sales we may send you text alerts in response
            to your initiated text message. Message and data rates may apply, depending on your
            mobile phone service plan. At any time you can get more help by replying
            <strong>HELP</strong> to these texts, or you can opt out completely by replying
            <strong>STOP</strong>. Mobile Terms of Service are available at
            <a href="#terms-link" class="content-link">SMS Terms</a> and our Privacy Policy can be
            found at <a href="#privacy-link" class="content-link">Privacy Policy</a>."
          </p>
        </div>

        <h2 id="terms-link" class="section-title">League City Yacht Sales SMS Terms</h2>

        <ul class="terms-list">
          <li>
            <span class="number">1.</span>
            <div class="term-content">
              When you opt-in to League City Yacht Sales, you agree to receive messages related to
              initiated text conversations.
            </div>
          </li>
          <li>
            <span class="number">2.</span>
            <div class="term-content">
              You can cancel the SMS service after initiating a text conversation at any time by
              texting <strong>"STOP"</strong>. After you send the SMS message
              <strong>"STOP"</strong> to to us, we will send you an SMS message to confirm that you
              have been unsubscribed. After this, you will no longer receive SMS messages from us.
              If you want to join again, text <strong>"RESUME"</strong> to initiate SMS responses.
            </div>
          </li>
          <li>
            <span class="number">3.</span>
            <div class="term-content">
              If you are experiencing issues with the messaging program you can reply with the
              keyword <strong>"HELP"</strong> for more assistance, or you can get help directly at
              <a href="mailto:contact@leaguecityyachtsales.com" class="contact-info"
                >contact@leaguecityyachtsales.com</a
              >.
            </div>
          </li>
          <li>
            <span class="number">4.</span>
            <div class="term-content">
              Carriers are not liable for delayed or undelivered messages.
            </div>
          </li>
          <li>
            <span class="number">5.</span>
            <div class="term-content">
              Message and data rates may apply for any messages sent to you from us and to us from
              you. If you have any questions about your text plan or data plan, it is best to
              contact your wireless provider.
            </div>
          </li>
        </ul>

        <h2 id="privacy-link" class="section-title">Privacy Policy</h2>

        <p class="privacy-statement">
          League City Yacht Sales will not share consumer opt-in data and consent with any third
          parties for their own use case unless you provide express written consent to do so.
          No mobile information will be shared with third parties/affiliates for marketing/promotional purposes. All other categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.
        </p>
        <h2 class="section-title">Website analytics</h2>
        <p class="privacy-statement">
          With your permission, we use Google Analytics to understand visits to public pages,
          listing views and successful enquiries. Analytics cookies help measure site usage.
          Their browser identifiers can recognise repeat visits, but do not verify who you are.
          Clearing cookies or using another browser or device can create a different identifier.
          We do not send your contact-form name, email address, telephone number or message to Google Analytics.
          You can decline analytics or change your choice using Analytics preferences in the footer.
          We respect your browser's Do Not Track setting.
        </p>
      </div>
    </div>
  </div>
</section>
